import { useState } from 'react';

export default function EngagementBar() {
  const [showModal, setShowModal] = useState(false);
  const [callbackSuccess, setCallbackSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleCallbackSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitting(true);
    const form = e.currentTarget;
    const formData = new FormData(form);
    const data = new URLSearchParams();
    data.append('name', (formData.get('cb_name') as string) ?? '');
    data.append('email', (formData.get('cb_email') as string) ?? '');
    data.append('phone', (formData.get('cb_phone') as string) ?? '');
    data.append('preferred_time', (formData.get('cb_time') as string) ?? '');
    data.append('notes', (formData.get('cb_notes') as string) ?? '');
    data.append('source', 'Engagement Bar Callback');
    data.append('submitted_at', new Date().toISOString());

    try {
      const res = await fetch('https://readdy.ai/api/form/d6m88bdv117fnkj2h2pg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data.toString(),
      });
      if (res.ok) {
        setCallbackSuccess(true);
        form.reset();
        setTimeout(() => {
          setCallbackSuccess(false);
          setShowModal(false);
        }, 4000);
      }
    } catch (err) {
      console.error('Callback form error:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {/* Floating Engagement Bar */}
      <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 flex items-center gap-3 bg-[#0A1628] rounded-full px-5 py-3 shadow-2xl border border-white/10">
        <button
          onClick={() => {
            const btn = document.querySelector('#vapi-widget-floating-button') as HTMLElement | null;
            if (btn) btn.click();
          }}
          className="flex items-center gap-2 bg-[#D4A853] text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-[#B8923D] transition-all cursor-pointer whitespace-nowrap shadow-md"
        >
          <i className="ri-chat-3-line text-base"></i>
          Live Chat
        </button>
        <div className="w-px h-6 bg-white/20"></div>
        <button
          onClick={() => setShowModal(true)}
          className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-5 py-2.5 rounded-full text-sm font-semibold transition-all cursor-pointer whitespace-nowrap"
        >
          <i className="ri-phone-incoming-line text-base"></i>
          Request a Callback
        </button>
      </div>

      {/* Callback Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setShowModal(false)}
          ></div>
          <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md p-7 z-10">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#D4A853]/10 rounded-xl flex items-center justify-center">
                  <i className="ri-phone-incoming-line text-xl text-[#D4A853]"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#0A1628]">Request a Callback</h3>
                  <p className="text-xs text-gray-500">We'll call you back within 2 hours</p>
                </div>
              </div>
              <button
                onClick={() => setShowModal(false)}
                className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>

            {callbackSuccess ? (
              <div className="text-center py-8">
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-check-double-line text-3xl text-green-600"></i>
                </div>
                <h4 className="text-lg font-bold text-[#0A1628] mb-2">Callback Requested!</h4>
                <p className="text-sm text-gray-600">One of our security experts will call you back shortly.</p>
              </div>
            ) : (
              <form data-readdy-form id="engagement-bar-callback-form" onSubmit={handleCallbackSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">Full Name *</label>
                  <input
                    type="text"
                    name="cb_name"
                    required
                    placeholder="John Doe"
                    className="w-full px-4 py-2.5 bg-[#F8F9FA] border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#D4A853] text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">Phone Number *</label>
                  <input
                    type="tel"
                    name="cb_phone"
                    required
                    placeholder="(905) 123-4567"
                    className="w-full px-4 py-2.5 bg-[#F8F9FA] border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#D4A853] text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">Email Address</label>
                  <input
                    type="email"
                    name="cb_email"
                    placeholder="john@example.com"
                    className="w-full px-4 py-2.5 bg-[#F8F9FA] border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#D4A853] text-sm"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">Preferred Callback Time</label>
                  <select
                    name="cb_time"
                    className="w-full px-4 py-2.5 bg-[#F8F9FA] border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#D4A853] text-sm cursor-pointer"
                  >
                    <option value="">Any time during business hours</option>
                    <option value="Morning (8AM–12PM)">Morning (8AM – 12PM)</option>
                    <option value="Afternoon (12PM–3PM)">Afternoon (12PM – 3PM)</option>
                    <option value="Late Afternoon (3PM–6PM)">Late Afternoon (3PM – 6PM)</option>
                    <option value="ASAP">As soon as possible</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-1.5">Brief Note (optional)</label>
                  <textarea
                    name="cb_notes"
                    rows={2}
                    maxLength={500}
                    placeholder="e.g. Interested in alarm systems for my home..."
                    className="w-full px-4 py-2.5 bg-[#F8F9FA] border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#D4A853] text-sm resize-none"
                  ></textarea>
                </div>
                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full bg-[#D4A853] text-white py-3 rounded-full text-sm font-semibold hover:bg-[#B8923D] transition-all cursor-pointer whitespace-nowrap shadow-md flex items-center justify-center gap-2 disabled:opacity-60"
                >
                  {submitting ? (
                    <>
                      <i className="ri-loader-4-line animate-spin text-base"></i>
                      Submitting...
                    </>
                  ) : (
                    <>
                      <i className="ri-phone-incoming-line text-base"></i>
                      Request Callback
                    </>
                  )}
                </button>
                <p className="text-center text-xs text-gray-400">
                  Mon–Fri 8AM–6PM · Emergency line available 24/7
                </p>
              </form>
            )}
          </div>
        </div>
      )}
    </>
  );
}
